import React from "react";
import { useParams } from "react-router-dom";
import OilCheckForm from "./OilCheckForm";

function OilCheckFormSave() {
  const { id } = useParams();
  return <OilCheckForm id={id} id2={0} FromCome={"SAVE"} />;
}

export default OilCheckFormSave;
